/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { HouseLine, Info } from 'phosphor-react';
import logo from '../../assets/logo_rbg.png';

function InformedHeader() {
  return (
    <>
      <header
        className="bg-white flex-1 flex-column h-[170px] py-2 px-8
      md:justify-between align-center mx-[150px] shadow-lg
      md:flex md:h-16 justify-center text-center pr-12
      "
      >
        <div className="flex ">
          <a
            href="http://www.ipc-global.com/"
            className="flex w-full justify-center"
          >
            <img src={logo} alt="informed by data logo" className="h-12" />
          </a>
        </div>
        <div className="font-bold text-2xl md:text-xl pt-2">
          Hospital Outpatient Prospective Payment System (OPPS) | CMS
        </div>
        <div className="text-green-600 min-w-fit pt-4 flex text-xs md:text-md">
          <a
            href="http://www.ipc-global.com/"
            className="flex align-center hover:underline justify-center w-full"
          >
            <Info size={18} className="mr-2 text-gray-900" />
            Learn more about inFormed by Data at IPC Global
          </a>
        </div>
      </header>
      <div className="absolute top-0 right-0 pt-5 mr-4 ml-2">
        <a href="http://www.ipc-global.com/">
          <HouseLine size={22} color="#002f67" />
        </a>
      </div>
    </>
  );
}

export default InformedHeader;
